import { createFileRoute, redirect } from "@tanstack/react-router";

// Account deletion now lives on Privacy and data.
export const Route = createFileRoute(
	"/_saas/app/_account/settings/danger-zone",
)({
	beforeLoad: () => {
		throw redirect({ to: "/app/settings/privacy" });
	},
});
